import TextPanel from './TextPanel';
import './TextPanel.scss';
import textPanelSchema from './textPanelSchema';

export { TextPanel, textPanelSchema };
